import {
  GET_STOCK_AVAILABILITY_REQUEST,
  GET_STOCK_AVAILABILITY_SUCCESS,
  GET_STOCK_AVAILABILITY_FAILURE,
  DOWNLOAD_STOCK_AVAILABILITY_REQUEST,
  DOWNLOAD_STOCK_AVAILABILITY_SUCCESS,
  DOWNLOAD_STOCK_AVAILABILITY_FAILURE,
} from "./stockAvailabilityTypes";
import axios from "axios";
import Config from "../../../config/index";

let baseUrl = Config.baseUrl;
let baseUrlReport = Config.baseUrlReport;

const getStockAvailabilityRequest = () => {
  return {
    type: GET_STOCK_AVAILABILITY_REQUEST,
  };
};

const getStockAvailabilitySuccess = (payload) => {
  return {
    type: GET_STOCK_AVAILABILITY_SUCCESS,
    payload: payload,
  };
};

const getStockAvailabilityFailure = (error) => {
  return {
    type: GET_STOCK_AVAILABILITY_FAILURE,
    payload: error,
  };
};

const getStockAvailability = (
  pageNo,
  rowsPerPage,
  search,
  relectedRmw,
  selectedsf,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getStockAvailabilityRequest());
    let url = `${baseUrlReport}/stock?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&totalRmwQty=${relectedRmw}&totalSfQty=${selectedsf}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getStockAvailabilitySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getStockAvailabilityFailure(err.response));
      });
  };
};

const downloadStockAvailabilityRequest = () => {
  return {
    type: DOWNLOAD_STOCK_AVAILABILITY_REQUEST,
  };
};

const downloadStockAvailabilitySuccess = (payload) => {
  return {
    type: DOWNLOAD_STOCK_AVAILABILITY_SUCCESS,
    payload: payload,
  };
};

const downloadStockAvailabilityFailure = (error) => {
  return {
    type: DOWNLOAD_STOCK_AVAILABILITY_FAILURE,
    payload: error,
  };
};

const downloadStockAvailability = (
  pageNo,
  rowsPerPage,
  search,
  relectedRmw,
  selectedsf,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadStockAvailabilityRequest());
    let url = `${baseUrlReport}/stock?download=1&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&totalRmwQty=${relectedRmw}&totalSfQty=${selectedsf}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadStockAvailabilitySuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadStockAvailabilityFailure(err.response));
      });
  };
};

export { getStockAvailability, downloadStockAvailability };
